import { createRouter, createWebHistory } from "vue-router";

const routes = [
    {
        path: "/",
        component: () => import("./App.vue"),
        children: [
            {
                path: '',
                component: () => import('./HomeVer2026.vue'),
            },
            {
                path: '/survey',
                component: () => import('./Survey.vue'),
            },
            {
                path: '/survey-end',
                name: 'servey-end',
                component: () => import('./SurveyEnd.vue'),
                meta: { customLayout: true }
            },
            {
                path: '/cmo-form',
                component: () => import('./CmoForm.vue'),
            },
            {
                path: '/archive-2025',
                name: 'archive-2025',
                component: () => import('./Archive2025.vue'),
                meta: { customLayout: true }
            },
        ],
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, ) {
        if (to.hash) {
            const targetElement = document.querySelector(to.hash);
    
            if (targetElement) {
                const offset = 100;
                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
    
                return window.scrollTo({
                    top: elementPosition - offset,
                    behavior: 'smooth',
                });
            }
        }
        return { top: 0 };
    },
});

export default router;
